<template>
  <div />
</template>

<script setup lang="ts">
definePageMeta({
  middleware: ['widget']
})
</script>
